import {MeterSensorImpulseModel} from "./meter-sensor-impulse-model";
import {MeterTypeEnum} from "./meter-type.enum";
import {IRMeterTypeEnum} from './ir-meter-type.enum';

export class MeterSensorModel {
  name: string;
  meterType: MeterTypeEnum;

  irType: IRMeterTypeEnum;

  module: number;
  sensorId: number;

  seriesNumber: string;
  manufacturer: string;

  value?: number;
  smlValue?: string[];
  impulse?: MeterSensorImpulseModel;

  image?: string;

  customName?: string;

  constructor() {
    this.name = '';
    this.meterType = null;
    this.irType = null;
    this.module = null;
    this.sensorId = null;
    this.seriesNumber = '';
    this.manufacturer = '';
    this.value = null;
    this.smlValue = [];
    this.impulse = null;
    this.image = '';
  }
}
